import axios from "axios";

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    // baseURL: "https://bureal-back-end.devio.codes/",
    // baseURL: "http://localhost:3001/",
});

export default api;